import React from "react";
import { Link } from "react-router-dom"


import FilterClients from "./components/Filter"

export default () => {
    function editClient(client) {
        window.location.href = `/clients/${client.id}`
    }
    return <div className="container">
        <div className="row">
            <div className="col-12">
                <p className="lead">
                    Clientes
                </p>
                <p className="lead">
                    Clique <Link to="/clients/create">aqui</Link> para cadastrar um novo cliente
                </p>

            </div>
            <div className="col-12">
                <FilterClients onClick={editClient} />
            </div>
        </div>
    </div>
}


// WEBPACK FOOTER //
// ./src/views/AppViews/Clients/index.jsx